import script from "./WhiteList.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhiteList.vue?vue&type=script&setup=true&lang=ts"

import "./WhiteList.vue?vue&type=style&index=0&id=b6db325a&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6db325a"]])

export default __exports__